module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "3"
    }
  }, [_c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Contract No")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllContractList'],
      "id": "fk_contract_id",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Contract NUMBER"
    },
    on: {
      "input": function($event) {
        _vm.getContractNoBasedVessel(_vm.Filter.fk_contract_id);
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.fk_contract_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_contract_id", $$v)
      },
      expression: "Filter.fk_contract_id"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Vessel Name :")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllContractBasedVesselList'],
      "id": "vessel_name",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Vessel Name"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.fk_ccbm_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_ccbm_id", $$v)
      },
      expression: "Filter.fk_ccbm_id"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "serach_txt",
      "name": "serach_txt",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.serach_txt),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "serach_txt", $$v)
      },
      expression: "Filter.serach_txt"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-5",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.DateTypeFilter ||
        _vm.Filter.JobNoFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.TransportTypeFilter ||
        _vm.Filter.paymentTypeFilter ||
        _vm.Filter.SOBFilter ||
        _vm.Filter.ShipemntTypeFilter ||
        _vm.Filter.PORFilter ||
        _vm.Filter.POLFilter ||
        _vm.Filter.PODFilter ||
        _vm.Filter.FPODFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.serach_txt ||
        _vm.Filter.contract_no ||
        _vm.Filter.fk_contract_id ||
        _vm.Filter.fk_ccbm_id ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.DateTypeFilter ||
    _vm.Filter.JobNoFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.TransportTypeFilter ||
    _vm.Filter.paymentTypeFilter ||
    _vm.Filter.SOBFilter ||
    _vm.Filter.ShipemntTypeFilter ||
    _vm.Filter.PORFilter ||
    _vm.Filter.POLFilter ||
    _vm.Filter.PODFilter ||
    _vm.Filter.FPODFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.serach_txt ||
    _vm.Filter.contract_no ||
    _vm.Filter.fk_contract_id ||
    _vm.Filter.fk_ccbm_id ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getAnalysisList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-5",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getAnalysisList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "50",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.getAnalysisList.length) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Date Type"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.DateTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "DateTypeFilter", $$v)
      },
      expression: "Filter.DateTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Job NO Filter",
      "id": "JobNoFilter",
      "name": "JobNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.JobNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "JobNoFilter", $$v)
      },
      expression: "Filter.JobNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Transport Type"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.TransportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TransportTypeFilter", $$v)
      },
      expression: "Filter.TransportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ShipemntTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ShipemntTypeFilter", $$v)
      },
      expression: "Filter.ShipemntTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllPendingSlineInvDDList'],
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "id": "PORFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PORFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORFilter", $$v)
      },
      expression: "Filter.PORFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "id": "POLFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.POLFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POLFilter", $$v)
      },
      expression: "Filter.POLFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "id": "PODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODFilter", $$v)
      },
      expression: "Filter.PODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "id": "FPODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.FPODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPODFilter", $$v)
      },
      expression: "Filter.FPODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Contract No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Contract No Filter",
      "id": "contract_no",
      "name": "contract_no",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.contract_no),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "contract_no", $$v)
      },
      expression: "Filter.contract_no"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "serach_txt",
      "name": "serach_txt",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.serach_txt),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "serach_txt", $$v)
      },
      expression: "Filter.serach_txt"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getBrfAnalysisList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('b-col', {
    staticClass: "table-responsive tableMain ",
    attrs: {
      "cols": "12"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-right",
    attrs: {
      "colspan": "11"
    }
  }, [_c('h4', [_vm._v("Total BRF Containers:" + _vm._s(_vm.getTotalContainersTEUS.totBRFContainerCount))]), _vm._v(" "), _c('h4', [_vm._v("Total JOB Containers:" + _vm._s(_vm.getTotalContainersTEUS.usedtotalContainers))])]), _vm._v(" "), _c('th', [_c('h4', [_vm._v(" Total BRF TEUS:" + _vm._s(_vm.getTotalContainersTEUS.totBRFTeusCount))]), _vm._v(" "), _c('h4', [_vm._v(" Total JOB TEUS:" + _vm._s(_vm.getTotalContainersTEUS.usedtotalTEUS))])])])])]), _vm._v(" "), _c('b-table', {
    staticClass: "position-relative no-wrap",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getAnalysisList,
      "fields": _vm.AnalysisFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "checkbox",
      fn: function(row0) {
        return [_c('div', {
          staticClass: "d-flex align-items-center gap-2"
        }, [_c('b-button', {
          staticClass: "mr-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": row0.toggleDetails
          }
        }, [_c('md-icon', [_vm._v(_vm._s(row0.detailsShowing ? "expand_less" : "expand_more"))]), _vm._v("\n                  " + _vm._s(row0.detailsShowing ? "Hide More" : "Show More") + "\n                  Details\n                ")], 1)], 1)]
      }
    }, {
      key: "SN",
      fn: function(row0) {
        return [_c('div', {
          staticClass: "d-flex align-items-center gap-2"
        }, [_c('b-button', {
          staticClass: "mr-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": row0.toggleDetails
          }
        }, [_c('md-icon', [_vm._v(_vm._s(row0.detailsShowing ? "expand_less" : "expand_more"))]), _vm._v("\n                  " + _vm._s(row0.detailsShowing ? "Hide More" : "Show More") + "\n                  Details\n                ")], 1)], 1), _vm._v(" "), _c('span', [_vm._v("\n                " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n              ")])]
      }
    }, {
      key: "JobNO",
      fn: function(row0) {
        return _vm._l(((row0.item.JobNO ? row0.item.JobNO.split(',') : [])), function(job, index) {
          return _c('b-badge', {
            key: index,
            staticStyle: {
              "margin-left": "5px"
            },
            attrs: {
              "variant": "success"
            }
          }, [_vm._v("\n                " + _vm._s(job.trim()) + "\n              ")])
        })
      }
    }, {
      key: "JobSOB",
      fn: function(row0) {
        return _vm._l(((row0.item.JobSOB ? row0.item.JobSOB.split(',') : [])), function(sob, index) {
          return _c('b-badge', {
            key: index,
            staticStyle: {
              "margin-left": "5px"
            },
            attrs: {
              "variant": "success"
            }
          }, [_vm._v("\n                " + _vm._s(sob.trim()) + "\n              ")])
        })
      }
    }, {
      key: "BRFNo",
      fn: function(row0) {
        return _vm._l(((row0.item.BRFNo ? row0.item.BRFNo.split(',') : [])), function(brf, index) {
          return _c('b-badge', {
            key: index,
            staticStyle: {
              "margin-left": "5px"
            },
            attrs: {
              "variant": "warning"
            }
          }, [_vm._v("\n                " + _vm._s(brf.trim()) + "\n              ")])
        })
      }
    }, {
      key: "row-details",
      fn: function(row4) {
        return [_c('b-card', {
          staticStyle: {
            "background": "whiteSmoke"
          }
        }, [_c('b-row', [(row4.item.contractNo) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Contract No:")]), _vm._v(" " + _vm._s(row4.item.contractNo))])]) : _vm._e(), _vm._v(" "), (row4.item.ContractFrom) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Contract From :")]), _vm._v(" " + _vm._s(row4.item.ContractFrom)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.ContractTo) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Contract To :")]), _vm._v(" " + _vm._s(row4.item.ContractTo)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.vessel) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Vessel :")]), _vm._v(" " + _vm._s(row4.item.vessel)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.voyage) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Voyage :")]), _vm._v(" " + _vm._s(row4.item.voyage)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.ContractCreatedAt) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Contract Created At :")]), _vm._v(" " + _vm._s(row4.item.ContractCreatedAt)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.Sline) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Sline :")]), _vm._v("\n                      " + _vm._s(row4.item.Sline)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.POR) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("POR :")]), _vm._v(_vm._s(row4.item.POR)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.POL) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("POL:")]), _vm._v(" " + _vm._s(row4.item.POL))])]) : _vm._e(), _vm._v(" "), (row4.item.POD) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row4.item.POD))])]) : _vm._e(), _vm._v(" "), (row4.item.FPOD) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row4.item.FPOD))])]) : _vm._e(), _vm._v(" "), (row4.item.containerType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Container Type:")]), _vm._v(" " + _vm._s(row4.item.containerType))])]) : _vm._e(), _vm._v(" "), (row4.item.totalContainers) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Container Count:")]), _vm._v(" " + _vm._s(row4.item.totalContainers))])]) : _vm._e(), _vm._v(" "), (row4.item.totalTEUS) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Tues Count:")]), _vm._v(" " + _vm._s(row4.item.totalTEUS))])]) : _vm._e(), _vm._v(" "), (row4.item.usedContainers) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Used Container Count:")]), _vm._v(" " + _vm._s(row4.item.usedContainers))])]) : _vm._e(), _vm._v(" "), (row4.item.totalTEUS) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Used Tues Count:")]), _vm._v(" " + _vm._s(row4.item.totalTEUS))])]) : _vm._e(), _vm._v(" "), (row4.item.BookingVessel) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Booking Vessel Name:")]), _vm._v(" " + _vm._s(row4.item.BookingVessel))])]) : _vm._e(), _vm._v(" "), (row4.item.BookingVoyage) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Booking Vessel Voyage No:")]), _vm._v(" " + _vm._s(row4.item.BookingVoyage))])]) : _vm._e(), _vm._v(" "), (row4.item.BuyRate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Buy Rate:")]), _vm._v(" " + _vm._s(row4.item.BuyRate))])]) : _vm._e(), _vm._v(" "), (row4.item.SellRate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Selling Rate:")]), _vm._v(" " + _vm._s(row4.item.SellRate))])]) : _vm._e(), _vm._v(" "), (row4.item.Currency) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Currency:")]), _vm._v(" " + _vm._s(row4.item.Currency))])]) : _vm._e(), _vm._v(" "), (row4.item.Country) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Country:")]), _vm._v(" " + _vm._s(row4.item.Country))])]) : _vm._e(), _vm._v(" "), (row4.item.BookingSOB) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Booking SOB/ETD:")]), _vm._v(" " + _vm._s(row4.item.BookingSOB))])]) : _vm._e(), _vm._v(" "), (row4.item.JobSOB) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("JOB SOB/ETD:")]), _vm._v(" " + _vm._s(row4.item.JobSOB))])]) : _vm._e(), _vm._v(" "), (row4.item.ContinerRemark) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Container Remark:")]), _vm._v(" " + _vm._s(row4.item.ContinerRemark))])]) : _vm._e(), _vm._v(" "), (row4.item.JobNo) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row4.item.JobNo))])]) : _vm._e(), _vm._v(" "), (row4.item.JobSOB) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Job SOB:")]), _vm._v(" " + _vm._s(row4.item.JobSOB))])]) : _vm._e(), _vm._v(" "), (row4.item.JobVessel) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Job Vessel:")]), _vm._v(" " + _vm._s(row4.item.JobVessel))])]) : _vm._e(), _vm._v(" "), (row4.item.JobVoyage) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Job Voyage:")]), _vm._v(" " + _vm._s(row4.item.JobVoyage))])]) : _vm._e(), _vm._v(" "), (row4.item.MBL) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("MBL:")]), _vm._v(" " + _vm._s(row4.item.MBL))])]) : _vm._e(), _vm._v(" "), (row4.item.HBL) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("HBL:")]), _vm._v(" " + _vm._s(row4.item.HBL))])]) : _vm._e(), _vm._v(" "), (row4.item.EnqNo) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Enq No:")]), _vm._v(" " + _vm._s(row4.item.EnqNo))])]) : _vm._e(), _vm._v(" "), (row4.item.BRFNo) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("BRF No:")]), _vm._v(" " + _vm._s(row4.item.BRFNo))])]) : _vm._e(), _vm._v(" "), (row4.item.BRFEnqNo) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("BRF Enq No:")]), _vm._v(" " + _vm._s(row4.item.BRFEnqNo))])]) : _vm._e(), _vm._v(" "), (row4.item.BRFCreatedBy) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("BRF Created By:")]), _vm._v(" " + _vm._s(row4.item.BRFCreatedBy))])]) : _vm._e(), _vm._v(" "), (row4.item.BRFCreatedDate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("BRF Created At:")]), _vm._v(" " + _vm._s(row4.item.BRFCreatedDate))])]) : _vm._e(), _vm._v(" "), (row4.item.booking_no) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Booking No:")]), _vm._v(" " + _vm._s(row4.item.booking_no))])]) : _vm._e(), _vm._v(" "), (row4.item.bookingType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Booking Type:")]), _vm._v(" " + _vm._s(row4.item.bookingType))])]) : _vm._e(), _vm._v(" "), (row4.item.validity_doc) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [(row4.item.validity_doc.split(',')) ? _c('span', [(row4.item.validity_doc.split(',').length > 0) ? _c('b', _vm._l((_vm.sanitizedArray(row4.item.validity_doc.split(','))), function(item_doc, index_doc) {
          return _c('span', {
            key: index_doc
          }, [(item_doc != '' && row4.item.BookingStatus == '1') ? _c('b-button', {
            staticClass: "mb-1",
            staticStyle: {
              "margin-left": "2px",
              "font-size": "0.675rem"
            },
            attrs: {
              "size": "sm",
              "variant": "warning"
            },
            on: {
              "click": function($event) {
                _vm.PrintValidity_Doc(item_doc)
              }
            }
          }, [_vm._v("PDF")]) : _vm._e(), _vm._v(" "), _c('br')], 1)
        })) : _vm._e()]) : _vm._e()]) : _vm._e()], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-right",
    attrs: {
      "colspan": "11"
    }
  }, [_c('h4', [_vm._v("Total BRF Containers:" + _vm._s(_vm.getTotalContainersTEUS.totBRFContainerCount))]), _vm._v(" "), _c('h4', [_vm._v("Total JOB Containers:" + _vm._s(_vm.getTotalContainersTEUS.usedtotalContainers))])]), _vm._v(" "), _c('th', [_c('h4', [_vm._v(" Total BRF TEUS:" + _vm._s(_vm.getTotalContainersTEUS.totBRFTeusCount))]), _vm._v(" "), _c('h4', [_vm._v(" Total JOB TEUS:" + _vm._s(_vm.getTotalContainersTEUS.usedtotalTEUS))])])])])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "50",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47bc41b7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pricing/BRFVesselList.vue
// module id = 2584
// module chunks = 0